import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = '/api';

const CreateOrder = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    order_date: new Date().toISOString().split('T')[0],
    point_number: '',
    counterparty_id: '',
    route_id: '',
    driver_id: '',
    car_id: '',
    price: '',
    weight_kg: '',
    boxes_count: '',
    volume_m3: '',
    notes: ''
  });
  
  const [counterparties, setCounterparties] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Модальные окна для создания
  const [showNewCounterparty, setShowNewCounterparty] = useState(false);
  const [showNewDriver, setShowNewDriver] = useState(false);
  const [showNewCar, setShowNewCar] = useState(false);
  const [showNewRoute, setShowNewRoute] = useState(false);

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {
      const [cp, r, d, c] = await Promise.all([
        axios.get(`${API_URL}/counterparties`),
        axios.get(`${API_URL}/routes`),
        axios.get(`${API_URL}/drivers`),
        axios.get(`${API_URL}/cars`)
      ]);
      setCounterparties(cp.data);
      setRoutes(r.data);
      setDrivers(d.data);
      setCars(c.data);
    } catch (err) {
      console.error('Ошибка загрузки списков:', err);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.order_date || !formData.counterparty_id || !formData.driver_id || !formData.car_id) {
      setError('Заполните обязательные поля: дата, контрагент, водитель, авто');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const orderData = {
        order_date: formData.order_date,
        point_number: formData.point_number,
        counterparty_id: parseInt(formData.counterparty_id),
        route_id: parseInt(formData.route_id) || 1,
        driver_id: parseInt(formData.driver_id),
        car_id: parseInt(formData.car_id),
        price: formData.price ? parseInt(formData.price) : null,
        weight_kg: formData.weight_kg ? parseInt(formData.weight_kg) : null,
        boxes_count: formData.boxes_count ? parseInt(formData.boxes_count) : null,
        volume_m3: formData.volume_m3 ? parseFloat(formData.volume_m3) : null,
        notes: formData.notes
      };

      await axios.post(`${API_URL}/orders`, orderData);

      alert('✅ Заявка создана успешно!');
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Ошибка создания заявки:', err);
      setError('Ошибка: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.modal}>
      <div style={styles.modalContent}>
        <h2>📋 Новая заявка</h2>
        
        {error && <div style={styles.errorBox}>{error}</div>}

        <div style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>📅 Дата заявки *</label>
            <input
              type="date"
              value={formData.order_date}
              onChange={(e) => handleChange('order_date', e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>🎯 Номер точки</label>
            <input
              type="text"
              value={formData.point_number}
              onChange={(e) => handleChange('point_number', e.target.value)}
              style={styles.input}
              placeholder="96587МП"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>🏢 Контрагент *</label>
            <div style={styles.dropdownWithButton}>
              <select
                value={formData.counterparty_id}
                onChange={(e) => handleChange('counterparty_id', e.target.value)}
                style={styles.select}
              >
                <option value="">Выберите контрагента...</option>
                {counterparties.map(cp => (
                  <option key={cp.id} value={cp.id}>{cp.name}</option>
                ))}
              </select>
              <button 
                onClick={() => setShowNewCounterparty(true)}
                style={styles.btnCreate}
                title="Создать нового контрагента"
              >
                ➕
              </button>
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>🗺️ Маршрут</label>
            <div style={styles.dropdownWithButton}>
              <select
                value={formData.route_id}
                onChange={(e) => handleChange('route_id', e.target.value)}
                style={styles.select}
              >
                <option value="">Выберите маршрут...</option>
                {routes.map(r => (
                  <option key={r.id} value={r.id}>{r.name}</option>
                ))}
              </select>
              <button 
                onClick={() => setShowNewRoute(true)}
                style={styles.btnCreate}
                title="Создать новый маршрут"
              >
                ➕
              </button>
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>👨 Водитель *</label>
            <div style={styles.dropdownWithButton}>
              <select
                value={formData.driver_id}
                onChange={(e) => handleChange('driver_id', e.target.value)}
                style={styles.select}
              >
                <option value="">Выберите водителя...</option>
                {drivers.map(d => (
                  <option key={d.id} value={d.id}>{d.name}</option>
                ))}
              </select>
              <button 
                onClick={() => setShowNewDriver(true)}
                style={styles.btnCreate}
                title="Создать нового водителя"
              >
                ➕
              </button>
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>🚗 Автомобиль *</label>
            <div style={styles.dropdownWithButton}>
              <select
                value={formData.car_id}
                onChange={(e) => handleChange('car_id', e.target.value)}
                style={styles.select}
              >
                <option value="">Выберите автомобиль...</option>
                {cars.map(c => (
                  <option key={c.id} value={c.id}>{c.model} ({c.plate_number})</option>
                ))}
              </select>
              <button 
                onClick={() => setShowNewCar(true)}
                style={styles.btnCreate}
                title="Создать новый автомобиль"
              >
                ➕
              </button>
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>💰 Цена доставки</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => handleChange('price', e.target.value)}
              style={styles.input}
              placeholder="5000"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>⚖️ Вес, кг</label>
            <input
              type="number"
              value={formData.weight_kg}
              onChange={(e) => handleChange('weight_kg', e.target.value)}
              style={styles.input}
              placeholder="369"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>📦 Коробы</label>
            <input
              type="number"
              value={formData.boxes_count}
              onChange={(e) => handleChange('boxes_count', e.target.value)}
              style={styles.input}
              placeholder="181"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>📐 Объём, м³</label>
            <input
              type="number"
              step="0.01"
              value={formData.volume_m3}
              onChange={(e) => handleChange('volume_m3', e.target.value)}
              style={styles.input}
              placeholder="3.26"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>📝 Заметки</label>
            <textarea
              value={formData.notes}
              onChange={(e) => handleChange('notes', e.target.value)}
              style={styles.textarea}
              rows="4"
              placeholder="Адреса и комментарии"
            />
          </div>
        </div>

        <div style={styles.buttons}>
          <button 
            onClick={handleSubmit} 
            disabled={loading}
            style={styles.btnSave}
          >
            {loading ? 'Создание...' : '✅ Создать заявку'}
          </button>
          <button onClick={onClose} style={styles.btnCancel}>
            Отмена
          </button>
        </div>

        <p style={styles.hint}>* обязательные поля</p>
      </div>

      {/* Модальные окна для быстрого создания */}
      {showNewCounterparty && (
        <QuickCreateModal
          title="🏢 Новый контрагент"
          fields={[
            { name: 'name', label: 'Название*', type: 'text', required: true },
            { name: 'contact_person', label: 'Контактное лицо', type: 'text' },
            { name: 'phone', label: 'Телефон', type: 'text' },
            { name: 'address', label: 'Адрес', type: 'text' },
            { name: 'inn', label: 'ИНН', type: 'text' }
          ]}
          endpoint={`${API_URL}/counterparties`}
          onClose={() => setShowNewCounterparty(false)}
          onSuccess={(newItem) => {
            setCounterparties([...counterparties, newItem]);
            setFormData(prev => ({ ...prev, counterparty_id: newItem.id.toString() }));
            setShowNewCounterparty(false);
          }}
        />
      )}

      {showNewDriver && (
        <QuickCreateModal
          title="👨 Новый водитель"
          fields={[
            { name: 'name', label: 'ФИО*', type: 'text', required: true },
            { name: 'phone', label: 'Телефон', type: 'text' },
            { name: 'license_number', label: 'Номер прав', type: 'text' }
          ]}
          endpoint={`${API_URL}/drivers`}
          onClose={() => setShowNewDriver(false)}
          onSuccess={(newItem) => {
            setDrivers([...drivers, newItem]);
            setFormData(prev => ({ ...prev, driver_id: newItem.id.toString() }));
            setShowNewDriver(false);
          }}
        />
      )}

      {showNewCar && (
        <QuickCreateModal
          title="🚗 Новый автомобиль"
          fields={[
            { name: 'plate_number', label: 'Госномер*', type: 'text', required: true },
            { name: 'model', label: 'Модель*', type: 'text', required: true },
            { name: 'capacity', label: 'Грузоподъёмность (кг)', type: 'number' }
          ]}
          endpoint={`${API_URL}/cars`}
          onClose={() => setShowNewCar(false)}
          onSuccess={(newItem) => {
            setCars([...cars, newItem]);
            setFormData(prev => ({ ...prev, car_id: newItem.id.toString() }));
            setShowNewCar(false);
          }}
        />
      )}

      {showNewRoute && (
        <QuickCreateModal
          title="🗺️ Новый маршрут"
          fields={[
            { name: 'name', label: 'Название*', type: 'text', required: true },
            { name: 'start_point', label: 'Откуда*', type: 'text', required: true },
            { name: 'end_point', label: 'Куда*', type: 'text', required: true },
            { name: 'distance', label: 'Расстояние (км)', type: 'number' }
          ]}
          endpoint={`${API_URL}/routes`}
          onClose={() => setShowNewRoute(false)}
          onSuccess={(newItem) => {
            setRoutes([...routes, newItem]);
            setFormData(prev => ({ ...prev, route_id: newItem.id.toString() }));
            setShowNewRoute(false);
          }}
        />
      )}
    </div>
  );
};

// Компонент быстрого создания
const QuickCreateModal = ({ title, fields, endpoint, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    const requiredFields = fields.filter(f => f.required);
    for (const field of requiredFields) {
      if (!formData[field.name] || !formData[field.name].trim()) {
        setError(`Поле "${field.label}" обязательно для заполнения`);
        return;
      }
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(endpoint, formData);
      onSuccess(response.data);
    } catch (err) {
      setError('Ошибка: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContentSmall}>
        <h3>{title}</h3>
        
        {error && <div style={styles.errorBox}>{error}</div>}

        <div style={styles.form}>
          {fields.map((field, idx) => (
            <div key={idx} style={styles.formGroup}>
              <label style={styles.label}>{field.label}</label>
              <input
                type={field.type}
                onChange={(e) => setFormData(prev => ({ ...prev, [field.name]: e.target.value }))}
                style={styles.input}
                placeholder={field.label.replace('*', '')}
              />
            </div>
          ))}
        </div>

        <div style={styles.buttons}>
          <button 
            onClick={handleSubmit} 
            disabled={loading}
            style={styles.btnSave}
          >
            {loading ? 'Создание...' : '✅ Создать'}
          </button>
          <button onClick={onClose} style={styles.btnCancel}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1100,
  },
  modalContent: {
    background: '#fff',
    padding: '30px',
    borderRadius: '10px',
    width: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  modalContentSmall: {
    background: '#fff',
    padding: '25px',
    borderRadius: '10px',
    width: '400px',
    maxHeight: '80vh',
    overflowY: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  label: {
    fontWeight: 'bold',
    color: '#333',
  },
  input: {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '14px',
  },
  select: {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '14px',
    flex: 1,
  },
  dropdownWithButton: {
    display: 'flex',
    gap: '10px',
  },
  btnCreate: {
    padding: '10px 15px',
    background: '#5D396E',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  textarea: {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '14px',
    fontFamily: 'inherit',
    resize: 'vertical',
  },
  buttons: {
    display: 'flex',
    gap: '10px',
    marginTop: '20px',
  },
  btnSave: {
    flex: 1,
    padding: '12px',
    background: '#075A64',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  btnCancel: {
    flex: 1,
    padding: '12px',
    background: '#ccc',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  errorBox: {
    background: '#ffebee',
    color: '#c62828',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '15px',
  },
  hint: {
    marginTop: '15px',
    color: '#666',
    fontSize: '12px',
  },
};

export default CreateOrder;
